import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';

import Home from './pages/Home';
import About from './pages/About';
import ConferenceHall from './pages/ConferenceHall';
import ContactPage from './pages/ContactPage';
import NewsEventsPage from './pages/NewsEventsPage';
import BarRestaurant from './pages/BarRestaurant';
import SpaSteamCenter from './pages/SpaSteamCenter';
import GymCenter from './pages/GymCenter';
import GardenGrounds from './pages/GardenGrounds';
import TennisCourt from './pages/TennisCourt';
import OtherServicesDetail from './pages/OtherServices';

// Admin

import Dashboard from './admin/Dashboard';
import ProtectedRoute from './admin/ProtectedRoute';
import AdminLogin from './admin/AdminLogin';

const App = () => {
  const [language, setLanguage] = useState('en'); 

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'en' ? 'am' : 'en'));
  };


  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

const isAdminPath = window.location.pathname.startsWith('/admin');//hadder and footer restriction in admin

  return (
    <>
    <Router>
      <ScrollToTop />
    {!isAdminPath && <Header language={language} toggleLanguage={toggleLanguage} />}
      <Routes>
        <Route path="/" element={<Home language={language} />} />
        <Route path="/about" element={<About language={language}/>} />
        <Route path="/contact" element={<ContactPage language={language} />} />
        <Route path="/conference" element={<ConferenceHall  language={language}/>} />
        <Route path="/news-events" element={<NewsEventsPage language={language} />} />
        <Route path="/bar" element={<BarRestaurant language={language}/>} />
        <Route path="/spa" element={<SpaSteamCenter language={language}/>} />
        <Route path="/gym" element={<GymCenter language={language}/>} />
        <Route path="/garden" element={<GardenGrounds language={language}/>} />
        <Route path="/tennis" element={<TennisCourt language={language} />} />
        <Route path="/other-services" element={<OtherServicesDetail language={language}/>} />
        
<Route  path="/admin-login" element={<AdminLogin/>} />
        <Route
  path="/admin/*"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>

        {!isAdminPath && <Footer language={language} />}


    </Router>
        </>
  );
}

export default App;
